<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container">
        <a class="navbar-brand" href="./">
          <img
            class="img-fluid"
            src="../assets/ama.png"
            alt=""
            srcset=""
            style="width: 75px"
          />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <router-link class="nav-link" to="/">Dashboard</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/klaim">Klaim</router-link>
            </li>
          </ul>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <div @click="dialog = true" style="cursor: pointer">
                <v-img
                  max-height="100"
                  max-width="40"
                  style="margin-top: -10px"
                  class="float-right"
                  src="../assets/logo_login.png"
                ></v-img>
                {{ namalogin }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <b-modal v-model="dialog" :title="namalogin">
      <b-input
        placeholder="Ganti Password"
        v-model="new_pdw"
        type="password"
      ></b-input>
      <template v-slot:modal-footer>
        <b-overlay
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button variant="primary" @click="reset()">Reset Password</b-button>
        </b-overlay>
        <b-button variant="danger" @click="logout()" class="float-left">
          <b-icon icon="box-arrow-left"></b-icon>
          LogOut
        </b-button>
      </template>
    </b-modal>

    <!-- alert -->
    <div>
      <b-alert :show="notif_alert" dismissible>
        Berhasil Edit Password
      </b-alert>
    </div>
  </div>
</template>

<script>
import GlobalMixin from "../mixins/GlobalMixin";
import axios from "axios";
export default {
  name: "NavBar",
  props: ["username"],
  mixins: [GlobalMixin],
  data() {
    return {
      namalogin: ``,
      transporter_id: ``,
      dialog: false,
      new_pdw: "",
      loading: false,
      busy: false,
      notif_alert: false,
    };
  },
  mounted() {
    // this.setModelMixin(null)
  },
  created() {
    this.namalogin = localStorage.getItem(`transporter_name`);
    this.transporter_id = localStorage.getItem(`transporter_id`);
  },
  methods: {
    reset() {
      // console.log(this.new_pdw);
      if (!confirm(`Yakin reset password`)) {
        return;
      }
      this.loading = true;

      axios
        .post(`https://services.ama.id/eloading/reset`, {
          transporter_id: this.transporter_id,
          pwd: this.new_pdw,
        })
        .then((res) => {
          let objek = res.data;
          // console.log(objek);
          if (objek.respone_code == "200") {
            this.loading = false;
            this.new_pdw = ``;
            this.dialog = false;
            this.notif_alert = true;
          }
        })
        .catch(function (error) {
          // this.loading = false
          console.log(error);
        });
    },
    logout() {
      console.log("logout yehh..");
      localStorage.removeItem("transporter_name");
      localStorage.removeItem("transporter_id");
      localStorage.removeItem("isAuth");
      localStorage.removeItem("kode");
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>

<style>
.alert {
  float: right;
  position: fixed;
  right: 20px;
  top: 90px;
}
</style>